import { render, staticRenderFns } from "./create-quiz-reward.html?vue&type=template&id=1ab45d94&scoped=true&"
import script from "./create-quiz-reward.js?vue&type=script&lang=js&"
export * from "./create-quiz-reward.js?vue&type=script&lang=js&"
import style0 from "./create-quiz-reward.scss?vue&type=style&index=0&id=1ab45d94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab45d94",
  null
  
)

export default component.exports